import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "px-3 pb-3 font-size-12-400",
  style: {"color":"red"}
}

import FormField from "@/components/Forms/FormField.vue";
import {watch, reactive, shallowRef} from 'vue'
import moment from "moment";
import PhoneNumber from "@/components/locations-selector/PhoneNumber.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileDetails',
  props: {
  data: {
    type: Object,
  },
  color: {
    type: String,
  },
  buttonColor: {
    type: String,
  },
  edit: {
    type: Boolean,
    default: false
  },
},
  emits: ['save', 'edit', 'close'],
  setup(__props, { emit: __emit }) {

const defaultData = {
  title: '-',
  first_name: '-',
  last_name: '-',
  gender: '-',
  dob: '',
  email: '-',
  phone: '-',
  mobile: '-',
};

const props = __props

const emit = __emit

const state = reactive({
  ...defaultData, // Initialize with default data first
});

const emailValidationMessage = shallowRef('');

const handleSave = () => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (emailRegex.test(state.email)) {
    emit('save', { ...state, id: props.data?.id });
  } else {
    emailValidationMessage.value = 'Please enter a valid email address.';
  }
};

const handleClose = () => {
  emailValidationMessage.value = ''
  emit('close')
}

// Watch for changes in props.data to update state
watch(() => props.data, (newData) => {
  if (!newData) return; // Return early if data is undefined
  Object.keys(defaultData).forEach(key => {
    const typedKey = key as keyof typeof defaultData;
    state[typedKey] = newData[key] !== undefined && newData[key] !== null ? newData[key] : defaultData[typedKey];
  });
}, {immediate: true});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    class: "px-5 py-3",
    style: {"background-color":"#F5F5F5"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "px-3 mb-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "d-flex" }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createElementVNode("p", { class: "p-text-lg mt-2" }, "Personal Details", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_col, { class: "text-right" }, {
            default: _withCtx(() => [
              (!__props.edit)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    color: "#F5F5F5",
                    variant: "flat",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('edit')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: __props.color,
                        icon: "fa fa-pencil"
                      }, null, 8, ["color"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    color: "#F5F5F5",
                    variant: "flat",
                    onClick: handleSave
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: __props.buttonColor,
                        icon: "fas fa-save"
                      }, null, 8, ["color"])
                    ]),
                    _: 1
                  })),
              (__props.edit)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 2,
                    color: "#F5F5F5",
                    variant: "flat",
                    onClick: handleClose
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: __props.color,
                        icon: "fas fa-close"
                      }, null, 8, ["color"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_sheet, { class: "px-2 pt-3 pb-2 b-round-20" }, {
        default: _withCtx(() => [
          _createVNode(FormField, {
            modelValue: state.title,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.title) = $event)),
            editting: __props.edit,
            label: "Title",
            variant: "plain"
          }, null, 8, ["modelValue", "editting"]),
          _createVNode(FormField, {
            modelValue: state.first_name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.first_name) = $event)),
            editting: __props.edit,
            label: "First Name",
            variant: "outlined"
          }, null, 8, ["modelValue", "editting"]),
          _createVNode(FormField, {
            modelValue: state.last_name,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.last_name) = $event)),
            editting: __props.edit,
            label: "Last Name",
            variant: "outlined"
          }, null, 8, ["modelValue", "editting"]),
          _createVNode(FormField, {
            modelValue: state.gender,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.gender) = $event)),
            editting: __props.edit,
            label: "Gender",
            variant: "outlined"
          }, null, 8, ["modelValue", "editting"]),
          _createVNode(FormField, {
            modelValue: state.dob,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.dob) = $event)),
            editting: __props.edit,
            label: "Date of Birth",
            type: "date",
            variant: "outlined"
          }, null, 8, ["modelValue", "editting"]),
          _createElementVNode("p", _hoisted_1, _toDisplayString(emailValidationMessage.value), 1),
          _createVNode(_component_v_sheet, { class: "pt-6" }, {
            default: _withCtx(() => [
              _createVNode(PhoneNumber, {
                modelValue: state.phone,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((state.phone) = $event)),
                disabled: !__props.edit,
                label: "Phone"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_sheet, { class: "pt-6" }, {
            default: _withCtx(() => [
              _createVNode(PhoneNumber, {
                modelValue: state.mobile,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((state.mobile) = $event)),
                disabled: !__props.edit,
                label: "Mobile"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})